import Model from '~/models/Model';

export default class Ping extends Model {
  resource() {
    return 'v1/pings';
  }
}
